import { Component, ErrorHandler, Inject, ChangeDetectionStrategy, signal } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { VaihdaYritystaPyynto, VaihdaYritystaVastaus, VaihdettavaYritys } from '@lemon/core-firebase/model/login'

import { FirebaseLemonaid } from './_angular/service/firebase-lemonaid.service'
import { VersionTarkistusPalvelu } from './_angular/service/version-tarkistus.palvelu'
import { LadataanService } from './_jaettu-angular/service/ladataan.service'
import { LemonTranslationService } from './_jaettu-angular/service/lemon-translation.service'

export interface VaihdaYritysDialogData {
  nykyinenYritys: VaihdettavaYritys
  vaihdettavatYritykset: VaihdettavaYritys[]
}

@Component({
  templateUrl: './vaihda-yritys.dialog.html',
  styleUrls: ['./vaihda-yritys.dialog.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VaihdaYritysDialog {
  readonly virhe = signal<string>(null)
  readonly vaihdetaan = signal(false)

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: VaihdaYritysDialogData,
    private _dialogRef: MatDialogRef<VaihdaYritysDialog>,
    private _firebaseLemonaid: FirebaseLemonaid,
    private _versionTarkistusPalvelu: VersionTarkistusPalvelu,
    private _ladataanService: LadataanService,
    private _translationService: LemonTranslationService,
    private _errorHandler: ErrorHandler,
  ) {}

  async vaihda(yritys: VaihdettavaYritys) {
    if (this.vaihdetaan()) {
      return
    }
    this.vaihdetaan.set(true)
    this.virhe.set(null)
    this._ladataanService.aloitaLataaminen()

    try {
      const pyynto: VaihdaYritystaPyynto = {
        kohdeKayttajaAvain: yritys.kayttajaAvain,
        kohdeAsiakasAvain: yritys.asiakasAvain,
        env: 'w',
        ver: this._versionTarkistusPalvelu.annaVersio(),
        device: navigator.platform,
        os: navigator.userAgent,
      }
      const vastaus = await this._firebaseLemonaid.functionsCall<VaihdaYritystaPyynto, VaihdaYritystaVastaus>('loginVaihdaYritysta', pyynto)
      if (!vastaus?.tokens?.lemonaidToken) {
        this._errorHandler.handleError(vastaus?.e ?? 'no-response-or-no-data')
        this.virhe.set(this._translationService.lokalisoi(vastaus?.e === 'auth/user-disabled' ? 'app.vaihda-yritys-dialog.kayttaja-ei-aktiivinen' : 'app.vaihda-yritys-dialog.virhe'))
        this._lopeta()
        return
      }

      await this._firebaseLemonaid.authSignInWithCustomToken(vastaus.tokens.lemonaidToken)
      this._dialogRef.close(true)
      // Täysi uudelleenlataus, koska palveluiden tilat ja kuuntelijat on sidottu edellisen yrityksen asiakasAvaimeen
      window.location.assign('/')
    } catch (err) {
      this._errorHandler.handleError(err)
      this.virhe.set(this._translationService.lokalisoi('app.vaihda-yritys-dialog.virhe'))
      this._lopeta()
    }
  }

  private _lopeta() {
    this.vaihdetaan.set(false)
    this._ladataanService.lopetaLataaminen()
  }
}
